"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var router_1 = require("@angular/router");
var service_service_1 = require("../../Services/service.service");
var user_service_1 = require("../../Services/user.service");
var material_1 = require("@angular/material");
var ValidatePhoneComponent = /** @class */ (function () {
    function ValidatePhoneComponent(route, userService, mainService, data, dialogRef) {
        this.route = route;
        this.userService = userService;
        this.mainService = mainService;
        this.dialogRef = dialogRef;
        this._currentUserId = 0;
        this._currentUserPhone = '';
        this._validationCode = "";
        this._validationInProgress = false;
        this._sendingInProgress = false;
        this.afterRegClose = false;
        this.firstSendConfirmed = false;
        this.data = data;
    }
    Object.defineProperty(ValidatePhoneComponent.prototype, "currentUserPhone", {
        get: function () {
            return this._currentUserPhone;
        },
        set: function (value) {
            this._currentUserPhone = value;
        },
        enumerable: true,
        configurable: true
    });
    ValidatePhoneComponent.prototype.performPhoneValidation = function ($event) {
        var _this = this;
        this._validationInProgress = true;
        this.userService.validatePhone(this.currentUserId, this.validationCode).then(function (res) {
            _this.dialogRef.close();
            _this.mainService.route.navigate(["/"]);
            _this.mainService.showInformation('Phone validation succeeded');
            _this.mainService.showLogin(undefined, "Your registration succeeded ! Please log in...");
        }).catch(function (result) {
            _this._validationInProgress = false;
            _this.validationCode = "";
            _this.mainService.showError(result);
        });
    };
    Object.defineProperty(ValidatePhoneComponent.prototype, "currentUserId", {
        get: function () {
            return this._currentUserId;
        },
        set: function (value) {
            this._currentUserId = value;
        },
        enumerable: true,
        configurable: true
    });
    ValidatePhoneComponent.prototype.ngOnInit = function () {
        var userDataObject = this.data.userData;
        if (userDataObject) {
            this.currentUserId = parseInt(userDataObject.userId);
            this.currentUserPhone = userDataObject.userPhone;
            this.sendPhoneValidationSms(null);
        }
    };
    Object.defineProperty(ValidatePhoneComponent.prototype, "validationCode", {
        get: function () {
            return this._validationCode;
        },
        set: function (value) {
            this._validationCode = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ValidatePhoneComponent.prototype, "sendingInProgress", {
        get: function () {
            return this._sendingInProgress;
        },
        set: function (value) {
            this._sendingInProgress = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ValidatePhoneComponent.prototype, "allowPerformValidation", {
        get: function () {
            return !this._validationInProgress && this._validationCode.length == 6;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ValidatePhoneComponent.prototype, "validationInProgress", {
        get: function () {
            return this._validationInProgress;
        },
        enumerable: true,
        configurable: true
    });
    ValidatePhoneComponent.prototype.sendPhoneValidationSms = function (event) {
        var _this = this;
        this.sendingInProgress = true;
        this.userService.sendPhoneValidationMessage(this.currentUserId).then(function (res) {
            _this.sendingInProgress = false;
        }).catch(function (res) {
            _this.sendingInProgress = false;
            _this.mainService.showError(res);
        });
    };
    return ValidatePhoneComponent;
}());
exports.ValidatePhoneComponent = ValidatePhoneComponent;
